<script setup lang="ts">
const props = defineProps<{ elem: () => VueComponent | None; scrollScreen?: boolean; auto?: boolean }>()
const init3 = useInited('init3')

const scrollPosition = shallowRef<'none' | 'left' | 'rigth'>('left')
const isOverflow = shallowRef(false)
const timer2 = useTimeout()
const timer3 = useTimeout()

function scroll(toleft: boolean) {
  const elem = helpers.getHTMLElement(props.elem())
  const visible = myElem(elem, 'offsetWidth', 0)
  const w = props.scrollScreen ? visible : (visible / 3) * 2
  if (elem) elem.scrollBy({ left: toleft ? w * -1 : w, behavior: 'smooth' })
}

function onScroll() {
  timer2.set(() => {
    const target = helpers.getHTMLElement(props.elem())
    const parent = target?.parentElement
    if (!target || !parent) return

    const calc = () => {
      const scrollLeft = myElem(target, 'scrollLeft', 0)

      if (myElem(parent, 'offsetWidth', 0) + scrollLeft + 120 > myElem(target, 'scrollWidth', 0)) {
        return 'rigth'
      }
      return scrollLeft < 80 ? 'left' : 'none'
    }

    scrollPosition.value = calc()
  }, 100)
}

function checkSize() {
  timer3.set(() => {
    const elem = props.elem()
    const width = myElem(elem, 'offsetWidth', 0)
    const scrollW = myElem(elem, 'scrollWidth', 0)

    if (!helpers.isPositiveNumber(width) || !helpers.isPositiveNumber(scrollW)) return
    isOverflow.value = width + 10 < scrollW
    onScroll()
  }, 100)
}

onMounted(() => props.auto && checkSize())

defineExpose({ onScroll, checkSize })
</script>

<template>
  <template v-if="init3 && isOverflow">
    <LazyButtonActionArrow v-if="scrollPosition !== 'left'" :class="$style.a1" icon="left" height="80" width="40" :submit="() => unvoid(scroll(true))" :txt="undefined" />
    <LazyButtonActionArrow :class="$style.a2" :disabled="scrollPosition === 'rigth'" height="80" width="40" :submit="() => unvoid(scroll(false))" :txt="undefined" />
  </template>
</template>

<style module>
.a0 {
  composes: global(_absolute);
  composes: global(_mta);
  composes: global(_mba);
  composes: global(_shadow);

  bottom: 0;
  top: 0;

  z-index: 10;
}

.a1 {
  composes: a0;
  left: 0px;
  border-radius: 0 14px 14px 0;
}
.a2 {
  composes: a0;
  right: 0px;
  border-radius: 14px 0 0 14px;
}
</style>
